import { z } from "zod";
import { schemes } from "@zeal/common";

export const postGenerateCanadianPayrollOnboardingLinkSchema = z.object({
  companyID: schemes.companyID(),
});

export type TPostGenerateCanadianPayrollOnboardingLinkRequest = z.infer<
  typeof postGenerateCanadianPayrollOnboardingLinkSchema
>;
